import { useState } from "react";
import { cn } from "@/lib/utils";

// Gambar kamera. Taruh file milikmu di frontend\public\kamera\ dengan nama kamera.png
// (atau kamera.webp / kamera.jpg). Kalau belum ada, otomatis dipakai ilustrasi bawaan di bawah.
const SOURCES = ["/kamera/kamera.png", "/kamera/kamera.webp", "/kamera/kamera.jpg"];

export function CameraSvg({ className }) {
  const G = "#C6A56B";
  return (
    <svg viewBox="0 0 240 170" className={className} role="img" aria-label="Kamera">
      <rect x="44" y="26" width="20" height="12" rx="3" fill="#3A3A3A" />
      <rect x="184" y="24" width="24" height="14" rx="3" fill={G} />
      <rect x="10" y="36" width="220" height="116" rx="18" fill="#161616" />
      <rect x="10" y="72" width="220" height="5" fill={G} />
      <rect x="32" y="48" width="46" height="18" rx="4" fill="#070707" stroke={G} strokeWidth="1.2" />
      <rect x="168" y="46" width="44" height="20" rx="4" fill="#F3EBDD" />
      <path d="M180 46v20M192 46v20M204 46v20" stroke="#C9BDA3" strokeWidth="1" />
      <text x="120" y="62" textAnchor="middle" fontSize="8" letterSpacing="5" fill={G} fontFamily="sans-serif">DIRGA</text>
      <circle cx="120" cy="115" r="42" fill="#0E0E0E" stroke={G} strokeWidth="3" />
      <circle cx="120" cy="115" r="32" fill="#1B1B1B" stroke="#454545" strokeWidth="2" />
      <circle cx="120" cy="115" r="22" fill="#080808" stroke={G} strokeWidth="1" strokeOpacity=".7" />
      <circle cx="120" cy="115" r="11" fill="#12121A" />
      <circle cx="111" cy="106" r="5" fill="#fff" fillOpacity=".45" />
      <circle cx="129" cy="124" r="2.4" fill="#fff" fillOpacity=".25" />
      <rect x="26" y="124" width="26" height="14" rx="3" fill="#232323" />
    </svg>
  );
}

export default function CameraArt({ className = "" }) {
  const [i, setI] = useState(0);
  if (i >= SOURCES.length) return <CameraSvg className={className} />;
  return (
    <img
      src={`${process.env.PUBLIC_URL || ""}${SOURCES[i]}`}
      alt="Kamera"
      draggable={false}
      onError={() => setI((n) => n + 1)}
      // multiply: latar putih pada foto .jpg ikut hilang di atas latar krem
      className={cn("select-none mix-blend-multiply", className)}
    />
  );
}
